export default __webpack_public_path__ + "static/alawwal-bank-banner-059e88a475fd120b823ffa4e7d67c099.jpg";